/* The World Awaits product page: gallery thumbnails and the card picker.
   Both work without this file: the gallery shows its first image and the
   card stack shows its first card. */
(function () {
  if (window.worldAwaitsInit) return;
  window.worldAwaitsInit = true;

  function initGallery(root) {
    var main = root.querySelector('[data-wa-main]');
    var thumbs = root.querySelectorAll('[data-wa-thumb]');
    if (!main) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.srcset = thumb.dataset.srcset;
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt;
        thumbs.forEach(function (t) {
          t.removeAttribute('aria-current');
        });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  function initCards(root) {
    var pills = root.querySelectorAll('[data-wa-pill]');
    var cards = root.querySelectorAll('[data-wa-card]');
    var questions = root.querySelectorAll('[data-wa-question]');

    function select(index) {
      pills.forEach(function (p) {
        p.setAttribute('aria-pressed', p.dataset.waPill === String(index) ? 'true' : 'false');
      });
      questions.forEach(function (q) {
        q.hidden = q.dataset.waQuestion !== String(index);
      });
      /* The chosen card goes on top (pos 0); the rest keep their order behind it. */
      var pos = 1;
      cards.forEach(function (c) {
        c.dataset.pos = c.dataset.waCard === String(index) ? 0 : pos++;
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        select(pill.dataset.waPill);
      });
    });
    select(0);
  }

  /* Sale card and sale price ([data-wa-ends-at]): the end time comes from
     the section setting. Once it passes (pages served from cache, or a
     visitor still on the page at the deadline) the element hides, and a
     sibling marked [data-wa-after-end] (the regular price) shows instead.
     Also runs the card's countdown. Same format as lander-kit.js. */
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function formatRemaining(ms) {
    var total = Math.floor(ms / 1000);
    var days = Math.floor(total / 86400);
    var hms = pad(Math.floor((total % 86400) / 3600)) + ':' + pad(Math.floor((total % 3600) / 60)) + ':' + pad(total % 60);
    return days > 0 ? days + 'd ' + hms : hms;
  }

  function initPromo(card) {
    if (card.dataset.waPromoInit) return;
    card.dataset.waPromoInit = 'true';
    var endsAt = parseInt(card.dataset.waEndsAt, 10) * 1000;
    if (!endsAt) return;
    var countdown = card.querySelector('[data-wa-countdown]');

    function tick() {
      var remaining = endsAt - Date.now();
      if (remaining <= 0) {
        card.hidden = true;
        var after = card.parentElement && card.parentElement.querySelector('[data-wa-after-end]');
        if (after) after.hidden = false;
        return false;
      }
      if (countdown) countdown.textContent = formatRemaining(remaining);
      return true;
    }

    if (tick()) {
      var timer = setInterval(function () {
        if (!tick()) clearInterval(timer);
      }, 1000);
    }
  }

  function init() {
    document.querySelectorAll('[data-wa-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-wa-cards]').forEach(initCards);
    document.querySelectorAll('[data-wa-ends-at]').forEach(initPromo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-wa-gallery]').forEach(initGallery);
    event.target.querySelectorAll('[data-wa-cards]').forEach(initCards);
    event.target.querySelectorAll('[data-wa-ends-at]').forEach(initPromo);
  });
})();
